/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Offerstooltip2Inputs */

const id_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah total penawaran unik yang telah muncul di giveaway`)
};

const ms_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah tawaran unik yang telah muncul dalam pemberian`)
};

const da_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet antal unikke tilbud der har været i giveaways`)
};

const de_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzahl der einzigartigen Angebote, die in Giveaways vorkamen`)
};

const en_us2_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique offers that have appeared in giveaways`)
};

const es_es2_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de ofertas únicas que han aparecido en regalos`)
};

const es_mx2_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de ofertas únicas que han aparecido en regalos`)
};

const fil_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang bilang ng mga natatanging offer na lumitaw sa mga giveaway`)
};

const fr_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre total d'offres uniques ayant été proposées en gratuité`)
};

const it_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero totale di offerte uniche apparse nei giveaway`)
};

const hu_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ajándékokban megjelent egyedi ajánlatok teljes száma`)
};

const nl_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal aantal unieke aanbiedingen dat in giveaways is verschenen`)
};

const no_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antall unike tilbud som har dukket opp i giveaways`)
};

const pl_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba unikalnych ofert, które pojawiły się w rozdaniach`)
};

const pt_br2_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique offers that have appeared in giveaways`)
};

const pt_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número total de ofertas únicas que apareceram em ofertas grátis`)
};

const ro_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numărul total de oferte unice care au apărut în ofertele gratuite`)
};

const fi_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjakojen ainutlaatuisten tarjousten kokonaismäärä`)
};

const sv_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal unika erbjudanden som förekommit i utlottningar`)
};

const vi_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số ưu đãi độc nhất đã xuất hiện trong các đợt tặng miễn phí`)
};

const tr_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava oyunlarda görünen benzersiz teklif sayısı`)
};

const cs_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkový počet unikátních nabídek ve výprodejích`)
};

const bg_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ брой уникални оферти, които са се появили в безплатни игри`)
};

const ru_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общее количество уникальных предложений в раздачах`)
};

const uk_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загальна кількість унікальних пропозицій у роздачах`)
};

const ar_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي عدد العروض الفريدة التي ظهرت في الهدايا`)
};

const hi_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिवअवे में अद्वितीय ऑफ़र की कुल संख्या`)
};

const th_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำนวนข้อเสนอที่ไม่ซ้ำกันทั้งหมดที่เคยปรากฏในของแจกฟรี`)
};

const ja_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布に登場したユニークなオファーの総数`)
};

const zh_cn2_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique offers that have appeared in giveaways`)
};

const zh_hant1_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique offers that have appeared in giveaways`)
};

const ko_components_giveawaystats_offerstooltip2 = /** @type {(inputs: Components_Giveawaystats_Offerstooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of unique offers that have appeared in giveaways`)
};

/**
* | output |
* | --- |
* | "Total number of unique offers that have appeared in giveaways" |
*
* @param {Components_Giveawaystats_Offerstooltip2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_offerstooltip2 = /** @type {((inputs?: Components_Giveawaystats_Offerstooltip2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Offerstooltip2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "ms") return ms_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "da") return da_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "de") return de_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "fil") return fil_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "fr") return fr_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "it") return it_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "hu") return hu_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "nl") return nl_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "no") return no_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "pl") return pl_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "pt") return pt_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "ro") return ro_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "fi") return fi_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "sv") return sv_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "vi") return vi_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "tr") return tr_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "cs") return cs_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "bg") return bg_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "ru") return ru_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "uk") return uk_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "ar") return ar_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "hi") return hi_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "th") return th_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "ja") return ja_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_offerstooltip2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_offerstooltip2(inputs)
	return ko_components_giveawaystats_offerstooltip2(inputs)
});
export { components_giveawaystats_offerstooltip2 as "components.giveawayStats.offersTooltip" }